import { render, staticRenderFns } from "./BackgroundImage.vue?vue&type=template&id=1d4980af&scoped=true&"
import script from "./BackgroundImage.vue?vue&type=script&lang=js&"
export * from "./BackgroundImage.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundImage.vue?vue&type=style&index=0&id=1d4980af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4980af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d4980af')) {
      api.createRecord('1d4980af', component.options)
    } else {
      api.reload('1d4980af', component.options)
    }
    module.hot.accept("./BackgroundImage.vue?vue&type=template&id=1d4980af&scoped=true&", function () {
      api.rerender('1d4980af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Weekly/components/BackgroundImage.vue"
export default component.exports